<template>
  <div class="icon-container" :class="{'disabled':social.disabled}" :style="iconContainerStyle()">
    <fa-icon
      v-for="i in 2 "
      :key="i"
      class="icon drop-shadow-glow"
      :icon="['fab', (social.icon)]"
      @click="goTo()"
      :style="iconStyle(i)"
      :class="iconClass()"
      @mouseenter="setHover(social.name)"
      @mouseleave="hover=null"
    />
    <div class="sub-text">
      {{ social.disabled ? "[disabled]" : "" }}
      {{ social.name }}
      </div>
  </div>
</template>

<script>
/**
 * Shows the individual icons and handles glitch
 */
import StoreUtils from "@/scripts/utils/store"
import RandomUtils from "@/scripts/utils/random"
import { mapState } from "vuex"
export default {
  props: {
    social: Object,
  },
  data() {
    return {
      hover: false,
      style1: {},
      style2: {},
      storeWatch: null
    }
  },
  computed: {
    ...mapState(["touchEnabled"])
  },
  created() {
    this.storeWatch = StoreUtils.WatchGlitch(this.glitch, this.unglitch)
  },
  beforeDestroy() {
    this.storeWatch()
  },
  methods: {
    glitch() {
      const minOffset = -15
      const maxOffset = 15

      let divide = RandomUtils.RandomInt(0, 100)

      let style1Left = RandomUtils.RandomInt(minOffset, maxOffset)
      let style2Left = RandomUtils.RandomInt(minOffset, maxOffset)
      let style1Top = RandomUtils.RandomInt(minOffset, maxOffset)
      let style2Top = RandomUtils.RandomInt(minOffset, maxOffset)

      this.style1 = {
        "clip-path": `polygon(0 0, 100% 0, 100% ${divide}%, 0% ${divide}%)`,
        left: style1Left,
        top: style1Top
      }
      this.style2 = {
        "clip-path": `polygon(0 ${divide}%, 100% ${divide}%, 100% 100%, 0 100%)`,
        left: style2Left,
        top: style2Top
      }
    },
    unglitch() {
      this.style1 = {}
      this.style2 = {}
    },
    // go to a url
    goTo() {
      if (this.social.disabled) return
      window.open(this.social.url, "_blank")
    },

    // dynamic class for hover
    iconClass() {
      if (this.isHover()) return "hover"
      else return ""
    },
    iconStyle(i) {
      return this["style" + i]
    },
    // dynamic styling for icon hover
    iconContainerStyle() {
      if (this.isHover()) {
        return {
          opacity: 1,
          "margin-left": "2px"
        }
      } else {
        return {
          opacity: 0.5
        }
      }
    },
    // are we hovering over this social
    isHover() {
      return this.hover === this.social.name
    },
    setHover(name) {
      // cant set hover if touch
      if (this.touchEnabled) {
        return
      }
      this.hover = name
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/views/project-synthecite/styles/variables.scss";
.icon {
  font-size: 50px;
  cursor: pointer;
}

.icon path {
  stroke: rgba($green, 0.5);
  stroke-width: 10px;
  fill: transparent;
  transition: 0.5s all;
}
.icon.hover path {
  stroke: transparent;
  fill: rgba($green, 0.4);
}

.icon.disable {
  cursor: default;
}

.icon-container {
  position: relative;
  transition: 0.5s all;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  &.disabled {
    .icon path{
      stroke: rgba($red, 0.5);
    }
    .icon.hover path {
      fill: rgba($red, 0.4);
    }
    .sub-text { 
      color: $warning-text-color;
    }


    .icon {
      cursor: default;
    }
    &.icon {
      cursor: default
    }
  }

  &:hover {
    .sub-text {
      opacity:1;
    }
  }
  .sub-text {
    opacity:0;
    color: $text-color;
    font-size: 20px;
    margin-left: 10px;
    transition: 0.5s all;
  }


}
.icon-container .icon:not(:first-child) {
  position: absolute;
  top: 0;
  left: 0;
}
</style>